// views.app.reports.sbom

export default {
  title: 'Software Bill of Materials',
  description: ''
};
